import axios from '@/libs/api.request'
import config from '@/config'

export const getPersonlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/person/person/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getPerauditlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/person/demand/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationPeraudit = (data, meth) => {
  return axios.request({
    url: '/v1/person/demand/',
    method: meth,
    data
  })
}

export const operationPerson = (data, meth) => {
  return axios.request({
    url: '/v1/person/person/',
    method: meth,
    data
  })
}

export const getapplicationlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/person/application/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getPersonStatistics = () => {
  return axios.request({
    url: '/v1/person/statistics/',
    method: 'get'
  })
}
